<div class="grid m-0 p-0">
  <div class="col-12 m-0 p-0">
    <!-- [(value)]="messages" -->
    <p-messages
      [enableService]="false"
      [closable]="true"
    ></p-messages>
  </div>
  <div class="col-12 m-0 p-0 mt-4">
    <split-table
      card-body
      [dados]="(lista$ | async)!"
      theme="primary"
      [widthColumns]="[10, 10, 30, 2]"
    >
      <ng-template #header>
        <div class="w-full text-left ml-6">Tipo</div>
      </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="width-full text-left ml-6">
          <span class="orange-text ml-">{{ item.name }}</span>
        </div>
      </ng-template>

      <ng-template #header>Acesso</ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <split-badge [titles]="iterateEmployees(item.employees)"></split-badge>
      </ng-template>
      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <!-- espaço vazio -->
      </ng-template>

      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="flex align-items-center justify-content-around mr-4">
          <p-button
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (onClick)="$event.stopPropagation(); editItem(item)"
          >
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon name="edit" size="20"></split-icon>
              </div>
            </ng-template>
          </p-button>
          <p-button
            class="ml-2"
            [rounded]="true"
            [text]="true"
            severity="danger"
            (onClick)="deleteItem(item.id)"
            >
            <!-- (onClick)="$event.stopPropagation(); deleteCard()" -->
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon name="trash" size="20"></split-icon>
              </div>
            </ng-template>
          </p-button>
        </div>
      </ng-template>
    </split-table>
  </div>
  <div class="col-12 m-0 p-0">
    <div class="col-12 m-0 p-0 mt-7 text-right">
      <p-button
        (onClick)="showForm()"
        class="ml-4"
        label="Adicionar pasta"
      ></p-button>
    </div>
  </div>
</div>
